var map = {
	"./MidnightFerg.jpg": "6cdc",
	"./bird-640.jpg": "a083",
	"./bread-640.jpg": "8e8a",
	"./cd-640.jpg": "20b9",
	"./coffee-640.jpg": "04eb",
	"./coffee2-640.jpg": "15f5",
	"./fishing-640.jpg": "3e54",
	"./moon-640.jpg": "5e67",
	"./water-lily-640.jpg": "ec05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "25ca";